import React from 'react';
import graph from './graph';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { isEmptyObject } from 'helpers/formatObject';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';
import { Stack, Avatar, Button, Typography, CircularProgress } from '@mui/material';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

export default function ReadyCouponRequest({ id, refetch, disabled = false }) {
  const [open, setOpen] = React.useState(false);
  const { userToken } = useSelector((state) => state.auth);
  const [request, { loading }] = useMutation(graph.ready.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onRequest = async () => {
    try {
      const { data, errors } = await request({
        context: {
          serviceName: graph.ready.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          coupon_id: id,
          status: 'TODO',
          type: 'READY_COUPON',
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.ready.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <Button
        sx={{ minWidth: 80 }}
        size="medium"
        color="secondary"
        variant="contained"
        onClick={onOpen}
        disabled={disabled}
        loading={loading}
        endIcon={<ThumbUpAltRoundedIcon color="inherit" fontSize="small" />}
      >
        فعالسازی
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title="درخواست فعالسازی" onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack flex={1} rowGap={2} alignItems="center" justifyContent="center" bgcolor="background.paper">
            <Avatar
              variant="rounded"
              sx={{
                width: 120,
                height: 120,
                fontSize: 80,
                borderRadius: 4,
                bgcolor: 'action.hover',
              }}
            >
              <ThumbUpAltRoundedIcon color="secondary" fontSize="inherit" />
            </Avatar>
            <Typography variant="subtitle1">آیا از فعالسازی این بن مطمئن هستید؟</Typography>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button color="warning" variant="outlined" onClick={onClose}>
            فعلا نه
          </Button>
          <Button
            autoFocus
            color="secondary"
            variant="contained"
            disabled={loading}
            onClick={onRequest}
            sx={{ minWidth: 80 }}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : 'بله'}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
